import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { ParamMap } from '@angular/router';

export const urlParamsResolver: ResolveFn<ParamMap> = (route, state) => {
  return route.queryParamMap;
};
